import { useQuery } from "@tanstack/react-query";
import useApi from "@/core/api/useApi";
import { useAuth } from "@/core/auth";
import { useBusiness } from "@/core/business/use-business";
import type { FlipperFeatureFlags } from "./featureFlags";

export const featureFlagsKey = (businessId?: string | null) =>
  ["feature_flags", businessId] as const;

export const useGetFeatureFlags = () => {
  const api = useApi();
  const { businessId } = useBusiness();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: featureFlagsKey(businessId),
    queryFn: async () =>
      api
        .get<FlipperFeatureFlags>(`/flipper/actors/Business;${businessId}`)
        .then((res) => res.data.features),
    enabled: isAuthenticated && !!businessId,
  });
};
